import { useTranslation } from 'react-i18next';

export const keyPrefix = 'goToCard';
export const useGoToCardTranslation = () => useTranslation('features', { keyPrefix });

export const ruRu = (__LOCALE_RU__ ? ({
  [keyPrefix]: {
    title: 'Карточка',
  },
}) : {}) as Record<string, unknown>;
export const en = (__LOCALE_EN__ ? ({
  [keyPrefix]: {
    title: 'Card',
  },
}) : {}) as Record<string, unknown>;
export const ptBr = (__LOCALE_PTBR__ ? ({
  [keyPrefix]: {
    title: 'Cartão',
  },
}) : {}) as Record<string, unknown>;
export const esEs = (__LOCALE_ESES__ ? ({
  [keyPrefix]: {
    title: 'Tarjeta',
  },
}) : {}) as Record<string, unknown>;
